import { SerializedError } from '@reduxjs/toolkit'

import { Bank, BankAccount } from './Bank'

export interface BankingState {
  banks: Bank[]
  selectedBankAccounts: BankAccount[]
  bankingUrl: string
  selectedBankId: string
  bankingConsentStatus: string
  status:
    | 'idle'
    | 'fetchingBanksByCountry'
    | 'creatingBankingUrl'
    | 'creatingBankingConsent'
    | 'removingBankingConsent'
    | 'succeed'
    | 'failed'
  error: SerializedError
}
